
import React, {Component, useState, useEffect} from 'react';

const CLS = 'reactDropDown';

const ReactDropDown = (props) => {
	const {
		activeOption,
		options,
		onSelect,
		title,
		id,
	} = props;

	return (
		<div className={`${CLS}`}>
			<span className={`${CLS}-sort-label text-dark d-block`}>{title}</span>
			<div className={`${CLS}-dropdown dropdown`}>
				<button className={`${CLS}-dropdown-toggle dropdown-toggle btn-sm`} type="button" id={`${id}`} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					{activeOption.label}
				</button>
				<div className="dropdown-menu" aria-labelledby={`${id}`}>
					{options.map((item, index) =>
						(
							<div className="dropdown-item" key={index} onClick={() => {onSelect(item)}}>{item.label}</div>
						))
					}
				</div>
			</div>
		</div>
	);
};

export default ReactDropDown;
